import { useShallow } from 'zustand/react/shallow'
import { useOfferStore, selectOffers } from '@store/offerStore'
import { OfferCard } from './OfferCard'
import { EmptyState } from './EmptyState'
import styles from './OfferGrid.module.css'

const SKELETON_KEYS = ['sk-1', 'sk-2', 'sk-3', 'sk-4', 'sk-5', 'sk-6', 'sk-7', 'sk-8']

export function OfferGrid() {
  const offers = useOfferStore(useShallow(selectOffers))
  const loading = useOfferStore(s => s.loading)
  const error = useOfferStore(s => s.error)
  const selectedWeek = useOfferStore(s => s.selectedWeek)
  const resetFilters = useOfferStore(s => s.resetFilters)

  if (loading) {
    return (
      <div className={styles.component}>
        {SKELETON_KEYS.map((key) => (
          <div key={key} className={`${styles.skeleton} ${styles.skeletonRow}`} />
        ))}
      </div>
    )
  }

  if (error) {
    return <EmptyState type="error" />
  }

  if (offers.length === 0) {
    const emptyType = selectedWeek === 'upcoming' ? 'no-upcoming' : 'no-results'
    return <EmptyState type={emptyType} onReset={selectedWeek !== 'upcoming' ? resetFilters : undefined} />
  }

  return (
    <div className={styles.component}>
      {offers.map((offer, index) => (
        <div
          key={offer.id}
          className={styles.cardWrapper}
          style={{ animationDelay: `${Math.min(index * 40, 600)}ms` }}
        >
          <OfferCard {...{ offer }} />
        </div>
      ))}
    </div>
  )
}
